import React, { useState } from 'react';
import { Header } from './components/Header';
import { CatalogPage } from './pages/CatalogPage';
import { VehicleDetail } from './pages/VehicleDetail';
import { MessageSquare } from 'lucide-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
export function App() {
  const [searchQuery, setSearchQuery] = useState('');
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-[#E8E8E8] font-sans text-[#1C1C1C]" data-id="element-1">
        <Header data-id="element-2" />

        <Routes data-id="element-3">
          <Route path="/" element={<CatalogPage searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-5" />} data-id="element-4" />
          <Route path="/autos/:id" element={<VehicleDetail data-id="element-7" />} data-id="element-6" />
        </Routes>

        <button className="fixed bottom-6 right-6 w-14 h-14 bg-[#D4A800] hover:bg-[#B89200] text-[#1C1C1C] rounded-full shadow-lg flex items-center justify-center transition-colors z-40" data-id="element-8">
          <MessageSquare className="w-6 h-6" data-id="element-9" />
        </button>
      </div>
    </BrowserRouter>;
}